import {lazy, Suspense, useLayoutEffect, useState} from 'react';
// import {lazy, Suspense} from 'react';
import css from './Banner.module.scss'
import {MdBackHand} from "react-icons/md";
// import {device, matchedMedia} from "../../utils/CheckDevice";
import {device, gpuTier, matchedMedia} from "../../utils/CheckDevice";
// import Particles from "./Particles";

let Wave = () => <></>
let Particles = () => <></>

const desktop = (device() === 'desktop' && matchedMedia())
if (desktop) Wave = lazy(() => import('./Wave'));
else Particles = lazy(() => import('./Particles'));

const Banner = () => {
    const dots = desktop ? 60 : 40
    const [gpu, setGpu] = useState({})
    //
    useLayoutEffect(() => {
        gpuTier().then(r => {
            setGpu(r)
            console.log(r)
        })
    }, [])

    return (
        <div id={css.Banner} className='bg-nfr-color-100 dark:bg-nfr-color-900'>
            <Suspense fallback={<></>}>
                <Particles dots={dots}/>
            </Suspense>
            <Suspense fallback={<></>}>
                {(desktop) && (gpu.tier >= 2 && gpu.fps >= 35 && !gpu.isMobile) &&
                // {(desktop) &&
                    <div className={css.waveAnimateIn}>
                        <Wave/>
                    </div>
                }
            </Suspense>
            {/*<div className={`${css.BannerTextContainer} ${Theme() === 'dark' ? 'dark-gradient' : ''}`}>*/}
            <div
                className={`${css.BannerTextContainer} bg-gradient-to-t from-nfr-color-100 from-[rgba(230, 241, 255, 0.8)] to-transparent dark:bg-gradient-to-t dark:from-nfr-color-900 dark:from-[rgba(30, 34, 42, 0.8)] dark:to-transparent`}>
                <div>
                    <h4 className={css.animateTextRight + ' ' + css.delay1 + ' flex items-center justify-center'}>
                        <MdBackHand className={css.Hand + ' ' + css.delay4 + ' text-amber-600 dark:text-amber-400'}/>
                        Hey there, it's me ...
                    </h4>
                    <h1 className={css.BannerMainText + ' ' + css.delay2 + ' ' + css.animateTextRight}>
                        Nahid Ferdous
                    </h1>
                    <h3 className={css.animateTextUp + ' ' + css.delay3}>
                        I am a <span className='text-amber-600 dark:text-amber-400'>Full Stack Web Developer</span>.
                    </h3>
                </div>
                <div className={css.scrollDownContainer + ' ' + css.animateTextUp + ' ' + css.delay4}>
                    <div className={`${css.scrollDown} border-2 border-nfr-color-900 dark:border-nfr-color-100`}>
                        <div className={`${css.ball} bg-nfr-color-900 dark:bg-nfr-color-100`}></div>
                    </div>
                    <small className={css.blink}>Scroll Down</small>
                </div>
            </div>
        </div>
    );
}

export default Banner;
